import React from 'react';
import { currencyFormat } from 'shared/utils/formatter';

const CurrencyFormat = ({
  value,
  currency,
  locale,
  className,
  ...opts
}) => {
  if (!currency) {
    return null;
  }

  return (
    <span className={className}>
      {currencyFormat(value, { currency, ...opts }, locale)}
    </span>
  );
};

export default CurrencyFormat;
